import type { ChatMessage } from '@chewy/chat-library-common';
import { Bubble } from '@chewy/chat-library-components';

export function General({ message }: { message?: ChatMessage }) {
  return (
    <Bubble responder={message?.responseType || 'user'}>
      {message?.content ?? message?.message ?? message?.payload?.body ?? ''}
    </Bubble>
  );
}

